import {checkGeoLocation} from "./geolocation";
import {showMessage} from "./modals";
import {uniqueUserId} from "./fingerprint2";

const readMore = (el) => {
    const parentEl = el.closest('.js-comment-item');

    let dots = parentEl.querySelector('.dots'),
        more = parentEl.querySelector('.more'),
        isHidden = dots.classList.contains('d-none');

    parentEl.querySelector('.js-show-more-text').innerHTML = isHidden ? parentEl.dataset.showText : parentEl.dataset.hideText;
    dots.classList.toggle('d-none');
    more.classList.toggle('d-none');
    el.classList.toggle('js-show-more-text-visible');
};

$(document).on('click', '.js-add-comment', function (e) {
    e.preventDefault();
    checkGeoLocation();

    window.canLikeItem = -1;

    const checkHasAnswerInterval = setInterval(() => {

        try {
            if (canLikeItem !== -1) {

                clearInterval(checkHasAnswerInterval);

                if (!canLikeItem) {
                    throw new Error(window.jsLocalizations['cannot_comment_too_far']);
                }

                if ($(this).data('route') && $(this).data('commentable-id')) {
                    const sendData = {
                        'id': +$(this).data('rateable-id'),
                        'comment': $.trim($(this).closest('.comment').find('input[name="comment"]').val()),
                        '_token': $('meta[name="csrf-token"]').attr('content'),
                        'uniqueUserId': uniqueUserId,
                    };
                    $.post($(this).data('route'), sendData, (ans) => {
                        if (ans.success) {
                            showMessage(window.jsLocalizations[ans.message] || ans.message, true, false, 'success');
                        } else {
                            showMessage(window.jsLocalizations[ans.error] || ans.error, false, false, 'error');
                            console.warn(window.jsLocalizations['error'] + ':', ans.error);
                        }
                    });
                }
            }

        } catch (e) {
            showMessage(window.jsLocalizations[e.message] || e.message, false, false, 'error');
        }
    }, 400);
});

document.querySelectorAll('.js-show-more-btn').forEach((el) => {
    el.addEventListener('click', (e) => {
        e.preventDefault();
        readMore(el);
    })
});
